export const AUTH_MODALE_DEFAULT_PROPS = {
    loginTitle: 'Connexion',
    loginDescription: 'Connectez-vous pour accéder à votre compte',
    loginButton: 'Connexion',
    registerTitle: 'Inscription',
    registerDescription: 'Créez un compte pour accéder à la plateforme',
    registerButton: 'Inscription',
    context: "signin",
};
